import React from "react";
import { Document, Page, StyleSheet, Font } from "@react-pdf/renderer";
import FontFranklinRegular from "../../../../../fonts/libre-franklin-v11-latin/libre-franklin-v11-latin-500.ttf";
import FontFranklinItalic from "../../../../../fonts/libre-franklin-v11-latin/libre-franklin-v11-latin-300italic.ttf";
import FontFranklinBold from "../../../../../fonts/libre-franklin-v11-latin/libre-franklin-v11-latin-700.ttf";
import PdfEIFSection from "../../eif/pdf-eif-section";
import PdfFooterV2 from "../../eif/PdfFooterV2";
import PdfHeaderV2 from "../../eif/pdf-header-v2";

interface PdfTemplateProps {
  data: {
    applicantId?: string | null | undefined;
    caseId: string | null | undefined;
    dateOfBirth: string | null | undefined;
    gender: string | null | undefined;
    lastName: string | null | undefined;
    restOfName: string | null | undefined;
    photoUrl: string | null | undefined;
    passportUrl: string | null | undefined;
    submissionDeadline: string | null | undefined;
  };
}

Font.register({
  family: "Libre Franklin",
  src: FontFranklinRegular,
});

Font.register({
  family: "Libre Franklin Italic",
  src: FontFranklinItalic,
});


Font.register({
  family: "Libre Franklin Bold",
  src: FontFranklinBold,
});

export const IdFormBlank: React.FC<PdfTemplateProps> = (props) => {
  
  const styles = StyleSheet.create({
    page: {
      fontFamily: "Libre Franklin",
      color: "black",
    },
  });

  return (    
    <Document>
      <Page size={{ width: 11.5 * 72, height: 8 * 72 }} style={styles.page}>
        <PdfHeaderV2 data={props.data}/>
        <PdfEIFSection
          applicantId={props.data.applicantId ?? ""}
          caseId={props.data.caseId ?? ""}
          nameOnDocument={
           `${props.data.restOfName} ${props.data.lastName}`
          }
          dateOfBirth={props.data.dateOfBirth ?? ""}
          gender={props.data.gender ?? ""}
          photoBlobUrl={props.data.photoUrl ?? ""}
          passportBlobUrl={props.data.passportUrl ?? ""} //TODO: remove this default value
        />
        <PdfFooterV2 data={props.data} />
      </Page>
    </Document>
  );
};
export default IdFormBlank;
